import type {
  ConnectAppOption,
  ConnectAppStack,
} from '../../../contracts/projects/integrations/connectAppChips.defaults';
import {
  DEFAULT_CONNECT_APP_CONNECTORS_MERGE,
  DEFAULT_CONNECT_APP_CONNECTORS_NANGO,
} from '../../../contracts/projects/integrations/connectAppChips.defaults';
export const resolveProjectConnectAppOptions = (
  connectors: readonly ConnectAppOption[] | readonly string[],
  stack: ConnectAppStack,
  catalog: { allowed: ReadonlySet<string>; label: (id: string) => string }
): ConnectAppOption[] => {
  const { allowed } = catalog;
  const source =
    connectors.length > 0
      ? connectors
      : stack === 'nango'
        ? DEFAULT_CONNECT_APP_CONNECTORS_NANGO
        : DEFAULT_CONNECT_APP_CONNECTORS_MERGE;

  const rows: ConnectAppOption[] = [];
  const seen = new Set<string>();
  for (const entry of source) {
    const id = typeof entry === 'string' ? entry : entry.id;
    if (!id || !allowed.has(id) || seen.has(id)) continue;
    seen.add(id);
    const fallback = catalog.label(id);
    rows.push({
      id,
      label: typeof entry === 'string' ? fallback : entry.label || fallback,
    });
  }
  return rows;
};
